import * as React from 'react';
import * as domain from '../domain';
import { InputField } from './InputField';
import { jsx as ___EmotionJSX } from "@emotion/react";
const {
  Answer,
  FeedbackHandler,
  InputFieldGrader,
  Question,
  Solution
} = domain;
export const InputFieldAdapter = _ref => {
  let {
    checkExercise,
    item,
    lastAttempt,
    submitExerciseCount
  } = _ref;
  const grader = React.useMemo(() => InputFieldGrader.fromItem(item), [item]);
  const feedbackHandler = React.useMemo(() => new FeedbackHandler(checkExercise), [checkExercise]);
  const solution = React.useMemo(() => Solution.fromItem(item), [item]);
  const question = React.useMemo(() => Question.fromItem(item), [item]);
  const lastAnswer = React.useMemo(() => Answer.extractAnswerFromCommand(lastAttempt), [lastAttempt]);
  return ___EmotionJSX(InputField, {
    feedbackHandler: feedbackHandler,
    grader: grader,
    initialAnswer: lastAnswer,
    question: question,
    solution: solution,
    submitExerciseCount: submitExerciseCount
  });
};